import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";

import AdminRoutes from "Routes/Components/Admin";

import moment from "Helpers/MomentCompat";

import { useFetch } from "Hooks/useFetch";

import Button from "Components/Admin/Buttons";
import Section from "Components/Admin/Section";
import Table from "Components/Admin/Table";

import { columns, downloadColumns } from "./columns";
import * as S from "./styles";

const NotificationDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { fetchData, loading } = useFetch();

  const [selectedNotification, setSelectedNotification] = useState({});
  const [userNotifications, setUserNotifications] = useState([]);

  useEffect(() => {
    if (id) {
      getNotification(id);
    }
    // eslint-disable-next-line
  }, [id]);

  const getNotification = async (id) => {
    const onSuccessCallback = (data) => {
      const notification = data;
      setSelectedNotification(notification);

      getUserNotification(id);
    };

    await fetchData({
      method: "post",
      path: "/notifications/get-notification-by-id",
      body: { notification_id: id },
      onSuccessCallback,
    });
  };

  const getUserNotification = async (id) => {
    const onSuccessCallback = (data) => {
      setUserNotifications(data);
    };

    await fetchData({
      method: "post",
      path: "/notifications/get-user-notifications-by-id",
      body: { notification_id: id },
      onSuccessCallback,
    });
  };

  const info = (title, value) => {
    return (
      <S.Info>
        <h3>{title}</h3>
        <span>{value}</span>
      </S.Info>
    );
  };

  return (
    <Section>
      <S.Wrapper>
        <S.Buttons>
          <Button
            type="button"
            text="Voltar"
            disabled={loading}
            onClick={() => navigate(AdminRoutes.ListNotifications.path)}
            width="30%"
          />
        </S.Buttons>

        {info("Título:", selectedNotification.title)}

        <S.Row>
          {info(
            "Data de início:",
            selectedNotification.start_at
              ? moment(selectedNotification.start_at).format("DD/MM/YYYY")
              : "Não definido",
          )}
          {info(
            "Data de término:",
            selectedNotification.finish_at
              ? moment(selectedNotification.finish_at).format("DD/MM/YYYY")
              : "Não definido",
          )}
        </S.Row>

        {info(
          "Link:",
          selectedNotification.link
            ? selectedNotification.link
            : "Não definido",
        )}

        <S.Row>
          {info("Níveis:", selectedNotification.levels?.join(", "))}

          {info("Automática:", selectedNotification.automatic ? "Sim" : "Não")}
        </S.Row>

        {info(
          "Data de inativação:",
          selectedNotification.inactivated_at
            ? moment(selectedNotification.inactivated_at).format("DD/MM/YYYY")
            : "Não definido",
        )}

        <S.Row>
          {info(
            "Criador:",
            selectedNotification.creator
              ? selectedNotification.creator.full_name
              : "Não definido",
          )}

          {info(
            "Data de criação:",
            selectedNotification.createdAt
              ? moment(selectedNotification.createdAt).format(
                  "DD/MM/YYYY HH:mm",
                )
              : "Não definido",
          )}
        </S.Row>

        <hr />

        {info("Usuários totais notificados:", 0)}

        {selectedNotification.target_users?.length
          ? info(
              "Usuário(s) alvo:",
              selectedNotification.target_users
                .map((user) => user.full_name)
                .join(", "),
            )
          : null}

        {selectedNotification.levels?.includes("Regular") ||
        selectedNotification.levels?.includes("Toast") ||
        selectedNotification.levels?.includes("Pop-up") ? (
          <>
            <h3>Visualizações:</h3>

            <Table
              name={
                "Visualizações da Notificação - " + selectedNotification.title
              }
              data={userNotifications}
              columns={columns}
              downloadColumns={downloadColumns}
            />
          </>
        ) : null}

        {selectedNotification.levels?.includes("E-mail") ? (
          <>
            <hr />
            <span>
              <strong>Esta notificação foi enviada via e-mail.</strong>
            </span>
          </>
        ) : null}
      </S.Wrapper>
    </Section>
  );
};

export default NotificationDetails;
